import React from "react";
import { useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Sidennav from "../dashboard/sidenavbar";
import Topnavbar from "../dashboard/topnavbar";

function Editintraassignment() {
  const accesstoken = localStorage.getItem("token");
  const accessuserid = localStorage.getItem("id");
  const Swal = require("sweetalert2");
  const { staff_id } = useParams();
  const navigate = useNavigate();

  const location = useLocation();
  const selval =
    location.state?.selectedOptions ||
    sessionStorage.getItem("selectedOptions");
  const searchVals =
    location.state?.searchVal || sessionStorage.getItem("searchVal");

  const [staff_name, setstaff_name] = useState("");
  const [staff_code, setstaff_code] = useState("");
  const [staff_dept, setstaff_dept] = useState("");
  const [staff_deptcode, setstaff_deptcode] = useState("");
  const [staff_deptid, setstaff_deptid] = useState("");
  const [staff_typename, setstaff_typename] = useState("");
  const [x, setX] = useState("");
  const [xy, setXY] = useState("");
  const [staff_typeid, setstaff_typeid] = useState("");
  const [staff_branchshift, setstaff_branchshift] = useState([]);
  const [status, setstaff_status] = useState("");
  const [shiftFrom, setShiftfrom] = useState("");
  const [shiftTo, setShiftTo] = useState("");
  const [staffBranch, setStaffBranch] = useState("");
  const [staffBranchid, setStaffBranchid] = useState("");
  const [branch_name, setbranch_name] = useState("");
  const [oldshift, setOldshift] = useState("");

  console.log("intraop:", selval);
  console.log("intrasearchVals:", searchVals);

  const handleBack = () => {
    const tab = location.state?.tab || "intra";
    navigate("/shiftassignment", {
      state: { tab, selval: selval, searchVal: searchVals },
    });
  };
  return (
    <div>
      <Topnavbar />
      <Sidennav />
      <div
        class="content-wrap"
        style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
      >
        <div className="container-fluid">
          <div style={{ display: "flex" }}>
            <button
              onClick={handleBack}
              className="float active-link"
              style={{ border: "none", background: " rgb(63, 41, 184)" }}
            >
              <i className="fa fa-arrow-left my-float"></i>
            </button>
          </div>

          <form>
            <div className="row">
              <div class="col-xl-12 col-xxl-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">EDIT INTRA SHIFT ASSIGNMENT</h4>
                  </div>
                  <div class="card-body">
                    <div class="basic-form mt-3">
                      <div class="form-row">
                        <div class="col-sm-2 mt-2 mt-sm-0">
                          <h6>Staff Code</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                            value={staff_code}
                          />
                        </div>
                        <div class="col-sm-4 mt-2 mt-sm-0">
                          <h6>Staff Name</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                          />
                        </div>

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Branch</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                          />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Department</h6>
                          <input
                            type="text"
                            class="form-control"
                            required
                            readOnly
                          />
                        </div>
                        <div className="col-sm-2 mt-2 mt-sm-0">
                          <h6>Department Code</h6>
                          <input class="form-control" readOnly />
                        </div>

                        {/* <div class="col-sm-4 mt-2 mt-sm-0">
                                                    <h6>Shift Type</h6>
                                                    <select
                                                        className="form-control select"
                                                        name="Shifttype"
                                                        value={staff_typeid}
                                                        onChange={(e) => { getshifttype(e.target.value);setstaff_typeid(e.target.value)}}
                                                    >
                                                        <option value="" disabled >
                                                            Select
                                                        </option>
                                                        {staff_branchshift}
                                                    </select>
                                                </div> */}

                        <div className="col-sm-4 mt-2 mt-sm-0">
                          <h6>Shift Type</h6>
                          <input class="form-control" readOnly />
                        </div>

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>From Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            readOnly
                            required
                          />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>To Date</h6>
                          <input
                            type="date"
                            class="form-control"
                            readOnly
                            required
                          />
                        </div>
                        {/* <div class="col-sm-2 mt-2 mt-sm-0">
                                                    <br />
                                                    <input readOnly type="checkbox" name="dept_status" className="selectsingle checku" id="exampleCheck1"
                                                          /><label className="form__label textal ml-2" for="clienttype">
                                                        Status
                                                    </label>
                                                </div> */}

                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>Shift Type</h6>
                          <select
                            className="form-control select"
                            name="Shifttypes"
                          >
                            <option value="" selected>
                              Select
                            </option>
                            {staff_branchshift}
                          </select>
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>From Date</h6>
                          <input type="date" class="form-control" required />
                        </div>
                        <div class="col-sm-3 mt-2 mt-sm-0">
                          <h6>To Date</h6>
                          <input type="date" class="form-control" required />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 offset-6 mt-4">
                    <button type="button" class="btn btn-primary mb-2">
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Editintraassignment;
